<template>
	<button
		:class="
			cn(
				'relative flex select-none items-center justify-center gap-8px rounded-full border border-n-100 bg-white p-[9px] text-n-950 hover:border-n-950 active:bg-b-10% disabled:pointer-events-none disabled:border-n-300 disabled:text-n-300 lg:px-16px lg:py-[13px]',
				props.class,
				buttonWithBadgeStyle,
			)
		"
		:disabled="isDisabled"
	>
		<BaseIcon
			name="filter_v2"
			class="h-24px w-24px cursor-pointer lg:h-16px lg:w-16px"
		/>

		<span class="typography-l1-emp hidden lg:inline">
			{{ buttonText }}
		</span>

		<BaseBadge
			v-if="showBadge"
			:count="itemCount"
			:max-count="maxCount"
			class="absolute -right-[8px] -top-[8px] bg-n-950"
		/>
	</button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
import BaseBadge from '@/components/ui/badge/BaseBadge.vue'
import { cn } from '@/lib/utils'
import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'

const props = defineProps({
	buttonText: {
		type: String,
		default: 'Filter',
	},
	isDisabled: {
		type: Boolean,
		default: false,
	},
	itemCount: {
		type: Number,
		default: 0,
	},
	maxCount: {
		type: Number,
		default: 99,
	},
	class: {
		type: String,
		default: '',
	},
})

const showBadge = computed(() => !props.isDisabled && props.itemCount > 0)
const buttonWithBadgeStyle = computed(() =>
	showBadge.value ? 'border-n-950' : '',
)
</script>

<style></style>
